import React, { useEffect, useState } from 'react'
import { Box , Button, CircularProgress, Typography , TextField} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InventoryBox from './InventoryBox';
import ApiService from '../../functions/apiService';

const InventoryNew = () => {
  const [nestedData , setNestedData] = useState([]);

  let loadData = () => {
    ApiService.get('/get-parent-location').then((data) => {
        const updatedData = data.data.data;
        setNestedData(updatedData);
    }).catch((e) => {
        console.error("error")
    })
   }

   useEffect(()=>{  
    loadData();
   }, []);

  return (
    <>
        <Box sx={{height:'69px', backgroundColor:'#fff', textAlign:'end', marginBottom:'30px'}}>
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                <Box>
                    <Button
                        variant="contained"
                        className='px-4'
                        sx={{
                            backgroundColor: '#FFC0C6', 
                            color:'#000',
                            fontSize:'15px',
                            fontWeight:'700',
                            borderRadius:'8px',
                            marginLeft:'20px',
                            marginTop:'10px',
                            '&:hover': {
                                backgroundColor: '#FFC0C6',
                                color: '#000', 
                            },
                        }}
                    >
                        Inventory Management
                    </Button>
                </Box>
                <Box>
                    <Typography sx={{
                        fontSize:'22px',
                        fontWeight:700,
                        color:'#BF1D2D',
                        marginTop:'10px',
                    }}>
                        FireHouse 247
                    </Typography>
                </Box>
                <Box>
                    <FormControl variant="outlined">
                        <OutlinedInput
                            id="outlined-adornment-weight"
                            aria-describedby="outlined-weight-helper-text"
                            placeholder='Search'
                            sx={{
                                height: '40px',
                                borderRadius: '60px',
                                marginRight:'80px',
                                width:'270px',
                                marginTop:'14px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#BF1D2D',
                                },
                                '& input::placeholder': {
                                    color: '#BF1D2D',
                                },
                            }}
                        />
                    </FormControl>
                </Box>
            </div> 
        </Box>
        
        <Box className='lines' style={{marginBottom:'50px'}}>
            <InventoryBox 
                key={nestedData.id}
                propdata = {nestedData}
                loadData = {loadData}
            />
        </Box>

        {(nestedData?.locations?.length < 1  && nestedData?.items?.length < 1) && (
          <>
            <div className='empty-firebox'>
              <img
                className='fire-img'
                src="/images/empty-firehouse.svg"
              />
              <div>
                    <p className='pt-5 inventory-text'>Start building your inventory now</p>
                </div>
            </div>
          </>
        )}
    </>
  )
}

export default InventoryNew